export default __webpack_public_path__ + "static/media/top.a47f0f26.png";